import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { compose } from "redux";
import { withModal, withPageStatus } from "../common";
import Title from "../common/Title";
import ReadOnly from "../common/ReadOnly";
import Back from "../../assets/Back";
import { track } from "../../api/heap";
import isKey from "../../utilities/keyboard-events";
import * as actions from "../../state/actions/onboarding";
var autocomplete;
var parser = require("parse-address");

const autoCompletedAddressFormats = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name"
};

class Address extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorAddress: null,
      autoCompletedAddress: {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        country: "",
        postal_code: ""
      },
      parsedAddress: {
        city: "",
        number: "",
        sec_unit_num: "",
        sec_unit_type: "",
        state: "",
        street: "",
        type: ""
      },
      formattedAddress: "",
      retry: true,
      continue: false
    };
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    // We might want to make sure our script is fully loaded, eh?
    this.initAutocomplete();

    const { address, city, state, zip, normalizedAddress } = this.props.user;
    if (address && city && state && zip) {
      // this.addressInput.value = this.formatAddress(address, city, state, zip);
      this.setState({
        formattedAddress: address
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { address, city, state, zip } = nextProps.user;
    if (address && city && state && zip) {
      this.setState({
        formattedAddress: address
      });
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handlePrevious = () => {
    this.props.previousStep();
  };

  handleNext = () => {
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    track("ONBOARDING_ADDRESS_STEP_CLICKED_CONTINUE");
    if (this.props.noValidate) {
      this.props.nextStep();
      return;
    }

    if (this.areFieldsValid()) {
      this.save();
    }

    if (this.props.pageComplete) this.props.nextStep();
  };

  areFieldsValid = () => {
    const { address, city, state, zip } = this.props.user;

    if (!address || !city || !state || !zip) {
      track("ONBOARDING_ERROR_ADDRESS_STEP", {
        message: "invalid_address"
      });
      this.setState({
        errorAddress: "A valid street, city, state, and zip are required"
      });
      this.setState({ transitioning: false });
      return false;
    }

    this.setState({
      errorAddress: null,
      error: null
    });
    return true;
  };

  save = async ({ fallback = false } = {}) => {
    if (!this.areFieldsValid) {
      this.setState({ transitioning: false });
      return false;
    }

    const {
      validateAddress,
      updateUserDatabase,
      updateStep,
      nextStep,
      user: { email, address, city, state, zip, unitNumber }
    } = this.props;

    const { retry } = this.state;

    const {
      parsedAddress: {
        city: pCity,
        number: pNumber,
        sec_unit_num,
        sec_unit_type,
        state: pState,
        street: pStreet,
        type: pType,
        zip: pZip
      }
    } = this.state;
    console.log("Google address is:", `${address} ${city} ${state} ${zip}`);
    console.log(
      "Parsed address is:",
      `${pNumber} ${pStreet} ${pType}, ${sec_unit_type} ${sec_unit_num}, ${pCity}, ${pState}, ${pZip}`
    );

    await validateAddress(
      {
        address: this.buildAddress({ fallback })
      },
      {},
      async ({
        valid,
        error,
        networkError,
        poBoxError,
        normalized_address,
        response
      }) => {
        this.setState({ poBoxError });
        if (!networkError && error && retry) {
          this.setState({ retry: false });
          this.save({ fallback: true });
          return;
        }
        this.setState({ retry: true, changed: false });
        if (!valid && !this.state.continue) {
          track("ONBOARDING_ERROR_ADDRESS_STEP", {
            message: "unmailable_address"
          });
          this.setState({
            errorAddress:
              error || "Unmailable address - make sure to include unit numbers"
          });
          this.setState({ transitioning: false });
          if (networkError) this.setState({ networkError: true });
          else this.setState({ networkError: false });
          return;
        }

        const addressPayload = {
          billingAddress: {
            street: address,
            city,
            state,
            zip,
            ...(unitNumber && { unitNumber }),
            normalized_address: normalized_address || {
              address_city: city,
              address_country_code: "US",
              address_postal_code: zip,
              address_street: `${address}${unitNumber ? ` ${unitNumber}` : ""}`,
              address_subdivision: state
            }
          }
        };

        if (this.state.continue) {
          axios.post("/api/v2/user-event", {
            type: "USER_ADDRESS_VALIDATION_BYPASSED",
            payload: {
              address: addressPayload,
              original_error: error || this.state.errorAddress || "unknown",
              original_response: (response || {}).data
            }
          });
        }

        const result = await updateUserDatabase(
          email,
          {
            ...addressPayload
            // shippingAddress: {
            //   street: address,
            //   city,
            //   state,
            //   zip,
            //   unitNumber,
            //   normalized_address
            // }
          },
          true
        );
        const { success } = result;
        if (success) {
          updateStep("address", { error: null });
          nextStep();
        } else {
          this.setState({ transitioning: false });
          updateStep("address", { error: "Error saving your information" });
        }
      }
    );
  };

  initAutocomplete = () => {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.
    autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      { types: ["geocode"] }
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    autocomplete.setFields(["address_component"]);

    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", () => {
      console.log("Place changed!");
      this.fillInAddress();
      this.setState({ addressFilled: true });
    });
  };

  fillInAddress = () => {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();
    if (!place.address_components) {
      // Address could not be parsed. Likely too short.
      return;
    }
    console.log("place:", place);
    // const { autoCompletedAddress, autoCompletedAddressFormats } = this.state;
    var n = {
      street_number: "",
      route: "",
      locality: "",
      administrative_area_level_1: "",
      country: "",
      postal_code: ""
    };

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (autoCompletedAddressFormats[addressType]) {
        var val =
          place.address_components[i][autoCompletedAddressFormats[addressType]];
        n[addressType] = val || "";
      }
    }

    const [address, city, state, zip] = [
      `${n.street_number || ""}${n.street_number && n.route ? " " : ""
      }${n.route || ""}`,
      n.locality || "",
      n.administrative_area_level_1 || "",
      n.postal_code || ""
    ];
    this.setState({
      autoCompletedAddress: n,
      formattedAddress: address
    });
    this.props.updateUser({
      address,
      city,
      state,
      zip
    });
    this.parseAddress(`${address}, ${city}, ${state}, ${zip}`);
  };

  // formatAddress = (address, city, state, zip) => {
  //   return `${address}, ${city}, ${state}, ${zip}`;
  // };

  buildAddress = ({ fallback }) => {
    let payload = {};
    const { autoCompletedAddress, parsedAddress } = this.state;
    const { address, city, state, zip, unitNumber } = this.props.user;

    if (fallback) {
      return {
        address_city: `${city}`,
        address_country_code: "US",
        address_postal_code: `${zip}`,
        address_street: `${address}`,
        ...(unitNumber && { address_street2: `${unitNumber}` }),
        address_subdivision: `${state}`
      };
    }
  };

  parseAddress = string => {
    const parsed = parser.parseLocation(string);
    if (!parsed) {
      return;
    }
    // const {
    //   city,
    //   number,
    //   sec_unit_num,
    //   sec_unit_type,
    //   state,
    //   prefix,
    //   street,
    //   type,
    //   zip
    // } = parsed;
    this.setState({
      parsedAddress: {
        ...parsed
      }
    });
    // const a = this.buildAddress();
    // this.props.updateUser({
    //   address: a.address_street,
    //   city: a.address_city,
    //   state: a.address_subdivision,
    //   zip: a.address_postal_code
    // });
  };

  renderStateOptions = () => (
    <>
      <option value="" disabled selected hidden>
        State
      </option>
      <option value="AL">Alabama</option>
      <option value="AK">Alaska</option>
      <option value="AZ">Arizona</option>
      <option value="AR">Arkansas</option>
      <option value="CA">California</option>
      <option value="CO">Colorado</option>
      <option value="CT">Connecticut</option>
      <option value="DE">Delaware</option>
      <option value="DC">District Of Columbia</option>
      <option value="FL">Florida</option>
      <option value="GA">Georgia</option>
      <option value="HI">Hawaii</option>
      <option value="ID">Idaho</option>
      <option value="IL">Illinois</option>
      <option value="IN">Indiana</option>
      <option value="IA">Iowa</option>
      <option value="KS">Kansas</option>
      <option value="KY">Kentucky</option>
      <option value="LA">Louisiana</option>
      <option value="ME">Maine</option>
      <option value="MD">Maryland</option>
      <option value="MA">Massachusetts</option>
      <option value="MI">Michigan</option>
      <option value="MN">Minnesota</option>
      <option value="MS">Mississippi</option>
      <option value="MO">Missouri</option>
      <option value="MT">Montana</option>
      <option value="NE">Nebraska</option>
      <option value="NV">Nevada</option>
      <option value="NH">New Hampshire</option>
      <option value="NJ">New Jersey</option>
      <option value="NM">New Mexico</option>
      <option value="NY">New York</option>
      <option value="NC">North Carolina</option>
      <option value="ND">North Dakota</option>
      <option value="OH">Ohio</option>
      <option value="OK">Oklahoma</option>
      <option value="OR">Oregon</option>
      <option value="PA">Pennsylvania</option>
      <option value="RI">Rhode Island</option>
      <option value="SC">South Carolina</option>
      <option value="SD">South Dakota</option>
      <option value="TN">Tennessee</option>
      <option value="TX">Texas</option>
      <option value="UT">Utah</option>
      <option value="VT">Vermont</option>
      <option value="VA">Virginia</option>
      <option value="WA">Washington</option>
      <option value="WV">West Virginia</option>
      <option value="WI">Wisconsin</option>
      <option value="WY">Wyoming</option>
    </>
  );

  render() {
    const {
      user: { address, city, state, zip, unitNumber, email, normalizedAddress },
      networkingError,
      updateUser,
      pageComplete,
      step: { error: stepError }
    } = this.props;
    const {
      handleNext,
      // formatAddress,
      parseAddress,
      areFieldsValid,
      renderStateOptions
    } = this;
    const {
      error,
      errorAddress,
      poBoxError,
      changed,
      networkError,
      autoCompletedAddress: {
        street_number,
        route,
        locality,
        administrative_area_level_1,
        country,
        postal_code
      }
    } = this.state;

    return (
      <>
        <div
          className="outerStack-mobile sm:outerStack"
          style={{ marginBottom: 88 }}
          onKeyDown={(e) => {
            if (isKey(e, ["enter"])) {
              console.log("yes it is entering...");
              handleNext();
            }
          }}
        >
          <div className="innerStack">
            <Title
              text={"What is your current residential address?"}
              disabled={pageComplete}
              disabledText={"Your address has been verified"}
            />
            <p className="pb-2">
              We will ship your card to this address!
            </p>
            <p className="pb-2">
            P.O. boxes are not accepted.
            </p>
            {errorAddress && (
              <div
                className="errorText w-10/12 pb-2 mx-auto"
                style={{ fontSize: 16 }}
              >
                {errorAddress}
              </div>
            )}
            <ReadOnly readOnly={pageComplete}>
              <input
                id="autocomplete"
                value={this.state.formattedAddress}
                placeholder="Address"
                type="text"
                className={`inputField inputFieldText ${errorAddress &&
                  "redBorder"}`}
                onChange={({ target: { value: address } }) => {
                  this.setState({ changed: true });
                  if (!address) {
                    this.setState({ autoCompletedAddress: {} });
                  }
                  parseAddress(address);
                  this.setState({ formattedAddress: address });
                  updateUser({
                    address,
                  });
                }}
                onFocus={() => this.setState({ continue: false })}
                // onBlur={e => parseAddress(e.target.value)}
                ref={(ref) => (this.addressInput = ref)}
                disabled={pageComplete}
              />
              <input
                type="text"
                value={unitNumber}
                placeholder="Apt/Suite/Unit # (if applicable)"
                className={`inputField inputFieldText ${errorAddress &&
                  "redBorder"}`}
                onChange={({ target: { value: unitNumber } }) => {
                  this.setState({ changed: true });
                  updateUser({
                    unitNumber,
                  });
                }}
                onFocus={() => this.setState({ continue: false })}
                disabled={pageComplete}
              />
              <input
                type="text"
                value={city}
                placeholder="City"
                className={`inputField inputFieldText ${errorAddress &&
                  "redBorder"}`}
                onChange={({ target: { value: city } }) => {
                  this.setState({ changed: true });
                  updateUser({
                    city,
                  });
                }}
                onFocus={() => this.setState({ continue: false })}
                disabled={pageComplete}
              />
              <div className="flex">
                <div className="flex-1">
                  <select
                    type="select"
                    value={state}
                    placeholder="State"
                    style={{
                      height: 50,
                      ...(!state ? { color: "gray" } : {}),
                    }}
                    className={`inputField inputFieldText ${errorAddress &&
                      "redBorder"}`}
                    onChange={({ target: { value: state } }) => {
                      this.setState({ changed: true });
                      updateUser({
                        state,
                      });
                    }}
                    onFocus={() => this.setState({ continue: false })}
                    disabled={pageComplete}
                  >
                    {renderStateOptions()}
                  </select>
                </div>
                <div className="flex-1 pl-4">
                  <input
                    type="text"
                    value={zip}
                    placeholder="Zip Code"
                    className={`inputField inputFieldText ${errorAddress &&
                      "redBorder"}`}
                    onChange={({ target: { value: zip } }) => {
                      this.setState({ changed: true });
                      updateUser({
                        zip,
                      });
                    }}
                    disabled={pageComplete}
                    onFocus={() => this.setState({ continue: false })}
                  />
                </div>
              </div>
              <div>
                {error && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    {error}
                  </div>
                )}
                {networkingError && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    Error saving your data
                  </div>
                )}
                {stepError && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    {stepError}
                  </div>
                )}
              </div>
            </ReadOnly>

            {errorAddress && !networkError && !poBoxError && !changed && (
              <div className="mt-2">
                <div className="text-sm mb-2 mx-auto w-10/12">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={this.state.continue}
                    onChange={(e) => {
                      this.setState({
                        continue: e.target.checked,
                      });
                    }}
                  />
                  <span>
                    I understand that if I choose to continue, my card may be
                    shipped to an invalid address.
                  </span>
                </div>
              </div>
            )}
            <button
              className="continueButton cursor-pointer"
              disabled={this.state.transitioning}
              style={{
                backgroundColor: this.state.transitioning ? "gray" : "#26E3BA",
              }}
              onClick={handleNext}
            >
              {this.state.transitioning ? (
                <i className="fas fa-solid fa-circle-notch fa-spin text-2xl" />
              ) : errorAddress && !this.state.continue ? (
                "Try Again"
              ) : (
                "Continue"
              )}
            </button>
          </div>
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText hidden">
            <div
              onClick={() => {
                this.props.previousStep();
              }}
            >
              <Back className="backButtonIcon" />
              <input
                type="button"
                name="button"
                value="Back"
                className="backButton"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      user: state.register.user,
      step: state.register.address,
      networkingError: state.register.networkingError,
      complete: state.register.applicationProgress.address
    }),
    actions
  ),
  withModal,
  withPageStatus("address")
)(Address);
